// extracted by mini-css-extract-plugin
export default {"author":"tLCcShR4","authorInfo":"jCarDijy","authorName":"sEvuTnxe","jobTitle":"jTDmoEIr","link":"lEbbOd7l"};